module.exports = __webpack_public_path__ + "img/logo-management.582b949d.png";